// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuiviPage_page__8NYZZ {
  width: 100%;
  min-height: calc(100vh - 10rem);
  padding: 1rem;
  box-sizing: border-box;
  background: #f5f8fb;
}

.SuiviPage_card__PsPU4 {
  max-width: 1480px;
  margin: 0 auto;
  overflow: visible;
  border: 1px solid #dce3e8;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(30, 55, 75, .06);
}

.SuiviPage_header__6eLfl {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px 14px;
  border-bottom: 1px solid #e2e8ed;
}

.SuiviPage_header__6eLfl h1 {
  margin: 0;
  color: #173f56;
  font-size: 1.25rem;
  font-weight: 700;
}

.SuiviPage_header__6eLfl p {
  margin: 5px 0 0;
  color: #667783;
  font-size: .84rem;
}

.SuiviPage_total__Jbljk {
  flex: 0 0 auto;
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf4f8;
  color: #2d647e;
  font-size: .78rem;
  font-weight: 600;
}

.SuiviPage_viewTabs__hxUCz {
  display: flex;
  gap: 4px;
  padding: 0 22px;
  border-bottom: 1px solid #e5ebef;
  background: #fff;
}

.SuiviPage_viewTabs__hxUCz button {
  padding: 12px 14px 10px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #667783;
  cursor: pointer;
  font: inherit;
  font-size: .82rem;
  font-weight: 600;
}

.SuiviPage_viewTabs__hxUCz button:hover,
.SuiviPage_viewTabs__hxUCz button:focus-visible {
  color: #173f56;
  outline: none;
}

.SuiviPage_viewTabs__hxUCz .SuiviPage_activeViewTab__O\\+ObX {
  border-bottom-color: #2f6b86;
  color: #173f56;
}

.SuiviPage_filters__GCJfd {
  position: relative;
  z-index: 20;
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr)) auto;
  align-items: end;
  gap: 10px;
  padding: 14px 22px;
  border-bottom: 1px solid #e5ebef;
  background: #f8fafb;
}

.SuiviPage_filters__GCJfd > label,
.SuiviPage_themeFilter__ASsOG {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
  color: #5f6f7b;
  font-size: .73rem;
  font-weight: 600;
}

.SuiviPage_filters__GCJfd select {
  min-height: 38px;
  padding: 7px 10px;
  border: 1px solid #cfd9e0;
  border-radius: 8px;
  background: #fff;
  color: #294252;
  font: inherit;
  font-weight: 400;
}

.SuiviPage_themeFilter__ASsOG {
  position: relative;
}

.SuiviPage_themeMultiSelect__5Quje {
  position: relative;
  color: #294252;
  font-weight: 400;
}

.SuiviPage_themeMultiSelect__5Quje summary {
  min-height: 38px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 30px 7px 10px;
  border: 1px solid #cfd9e0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  list-style: none;
  font-size: .73rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SuiviPage_themeMultiSelect__5Quje summary::-webkit-details-marker {
  display: none;
}

.SuiviPage_themeMultiSelect__5Quje summary::after {
  content: "⌄";
  position: absolute;
  right: 10px;
  color: #59717f;
  font-size: .9rem;
}

.SuiviPage_themeMultiSelect__5Quje[open] summary {
  border-color: #8fb2c3;
  box-shadow: 0 0 0 2px rgba(47, 107, 134, .08);
}

.SuiviPage_themeOptions__9I107 {
  position: absolute;
  z-index: 40;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  min-width: 240px;
  max-height: 330px;
  overflow-y: auto;
  padding: 7px;
  border: 1px solid #d4dfe5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(29, 54, 70, .14);
}

.SuiviPage_themeOptions__9I107 label {
  min-height: 34px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 9px;
  padding: 5px 7px;
  border-radius: 7px;
  color: #294252;
  cursor: pointer;
  font-size: .76rem;
  font-weight: 400;
}

.SuiviPage_themeOptions__9I107 label:hover {
  background: #f1f6f8;
}

.SuiviPage_themeOptions__9I107 input {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin: 0;
  accent-color: #2f6b86;
}

.SuiviPage_themeOptions__9I107 .SuiviPage_selectAllTheme__ouYON {
  color: #173f56;
  font-weight: 700;
}

.SuiviPage_themeOptionsSeparator__xi4h4 {
  height: 1px;
  margin: 5px 3px;
  background: #e6ecef;
}

.SuiviPage_clearFilters__QQcfq {
  min-height: 38px;
  padding: 7px 12px;
  border: 1px solid #b8cbd6;
  border-radius: 8px;
  background: #fff;
  color: #2c6079;
  cursor: pointer;
  font-size: .76rem;
  font-weight: 600;
}

.SuiviPage_clearFilters__QQcfq:hover {
  background: #eef6f9;
}

.SuiviPage_tableWrapper__vy5Cp {
  position: relative;
  z-index: 1;
  width: 100%;
  overflow-x: auto;
}

.SuiviPage_table__\\+dt58 {
  width: 100%;
  min-width: 1180px;
  border-collapse: collapse;
  color: #263746;
  font-size: .82rem;
}

.SuiviPage_table__\\+dt58 thead th {
  padding: 11px 12px;
  border-bottom: 1px solid #d9e1e6;
  background: #eef1f3;
  color: #294252;
  text-align: left;
  font-size: .76rem;
  font-weight: 700;
  white-space: nowrap;
}

.SuiviPage_table__\\+dt58 tbody td {
  padding: 12px;
  border-bottom: 1px solid #edf0f2;
  vertical-align: middle;
}

.SuiviPage_table__\\+dt58 tbody tr:last-child td {
  border-bottom: 0;
}

.SuiviPage_table__\\+dt58 tbody tr:hover {
  background: #f8fbfd;
}

.SuiviPage_status__0aQmE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  padding: 5px 8px;
  border: 1px solid currentColor;
  border-radius: 999px;
  font-size: .72rem;
  font-weight: 700;
  white-space: nowrap;
}

.SuiviPage_statusRequest__tER0e {
  color: #d45a5a;
  background: #fff0f0;
}

.SuiviPage_statusProposal__yWnik {
  color: #d36e8f;
  background: #fff1f6;
}

.SuiviPage_statusScheduled__vI2Hz {
  color: #b7771e;
  background: #fff7df;
}

.SuiviPage_statusCompleted__pwLUX {
  color: #2f8b5d;
  background: #eaf7f0;
}

.SuiviPage_values__UDmG5 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  min-width: 72px;
}

.SuiviPage_valueIcon__2mvhZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border: 1px solid currentColor;
  border-radius: 6px;
  background: #fff;
}

.SuiviPage_valueIcon__2mvhZ img {
  width: 16px;
  height: 16px;
}

.SuiviPage_bienveillance__BLKeD {
  color: var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
}

.SuiviPage_engagement__iJfBP {
  color: var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
}

.SuiviPage_faireEquipe__xe7OE {
  color: var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
}

.SuiviPage_respect__Lmfet {
  color: var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
}

.SuiviPage_theme__E7rg3 {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eaf5f9;
  color: #245b72;
  font-size: .72rem;
  font-weight: 600;
  white-space: nowrap;
}

.SuiviPage_titleCell__WNuse {
  min-width: 210px;
  color: #172d3b;
  font-weight: 600;
}

.SuiviPage_noData__2fUZf {
  color: #87939b;
}

.SuiviPage_state__mLgj4,
.SuiviPage_error__qCgVe {
  margin: 18px;
  padding: 28px 18px;
  border-radius: 10px;
  background: #f8fafb;
  color: #687782;
  text-align: center;
}

.SuiviPage_error__qCgVe {
  color: #b42318;
  background: #fff5f4;
}

@media (max-width: 1050px) {
  .SuiviPage_filters__GCJfd {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
}

@media (max-width: 760px) {
  .SuiviPage_page__8NYZZ {
    padding: .75rem;
  }

  .SuiviPage_header__6eLfl {
    flex-direction: column;
  }

  .SuiviPage_viewTabs__hxUCz {
    padding: 0 16px;
  }

  .SuiviPage_filters__GCJfd {
    grid-template-columns: 1fr;
    padding: 12px 16px;
  }

  .SuiviPage_themeOptions__9I107 {
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ValeurPage/SuiviPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".page {\r\n  width: 100%;\r\n  min-height: calc(100vh - 10rem);\r\n  padding: 1rem;\r\n  box-sizing: border-box;\r\n  background: #f5f8fb;\r\n}\r\n\r\n.card {\r\n  max-width: 1480px;\r\n  margin: 0 auto;\r\n  overflow: visible;\r\n  border: 1px solid #dce3e8;\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  box-shadow: 0 2px 8px rgba(30, 55, 75, .06);\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  padding: 20px 22px 14px;\r\n  border-bottom: 1px solid #e2e8ed;\r\n}\r\n\r\n.header h1 {\r\n  margin: 0;\r\n  color: #173f56;\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.header p {\r\n  margin: 5px 0 0;\r\n  color: #667783;\r\n  font-size: .84rem;\r\n}\r\n\r\n.total {\r\n  flex: 0 0 auto;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  background: #edf4f8;\r\n  color: #2d647e;\r\n  font-size: .78rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.viewTabs {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 0 22px;\r\n  border-bottom: 1px solid #e5ebef;\r\n  background: #fff;\r\n}\r\n\r\n.viewTabs button {\r\n  padding: 12px 14px 10px;\r\n  border: 0;\r\n  border-bottom: 3px solid transparent;\r\n  background: transparent;\r\n  color: #667783;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  font-size: .82rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.viewTabs button:hover,\r\n.viewTabs button:focus-visible {\r\n  color: #173f56;\r\n  outline: none;\r\n}\r\n\r\n.viewTabs .activeViewTab {\r\n  border-bottom-color: #2f6b86;\r\n  color: #173f56;\r\n}\r\n\r\n.filters {\r\n  position: relative;\r\n  z-index: 20;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr)) auto;\r\n  align-items: end;\r\n  gap: 10px;\r\n  padding: 14px 22px;\r\n  border-bottom: 1px solid #e5ebef;\r\n  background: #f8fafb;\r\n}\r\n\r\n.filters > label,\r\n.themeFilter {\r\n  display: flex;\r\n  min-width: 0;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  color: #5f6f7b;\r\n  font-size: .73rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.filters select {\r\n  min-height: 38px;\r\n  padding: 7px 10px;\r\n  border: 1px solid #cfd9e0;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #294252;\r\n  font: inherit;\r\n  font-weight: 400;\r\n}\r\n\r\n.themeFilter {\r\n  position: relative;\r\n}\r\n\r\n.themeMultiSelect {\r\n  position: relative;\r\n  color: #294252;\r\n  font-weight: 400;\r\n}\r\n\r\n.themeMultiSelect summary {\r\n  min-height: 38px;\r\n  display: flex;\r\n  box-sizing: border-box;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 7px 30px 7px 10px;\r\n  border: 1px solid #cfd9e0;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  list-style: none;\r\n  font-size: .73rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.themeMultiSelect summary::-webkit-details-marker {\r\n  display: none;\r\n}\r\n\r\n.themeMultiSelect summary::after {\r\n  content: \"⌄\";\r\n  position: absolute;\r\n  right: 10px;\r\n  color: #59717f;\r\n  font-size: .9rem;\r\n}\r\n\r\n.themeMultiSelect[open] summary {\r\n  border-color: #8fb2c3;\r\n  box-shadow: 0 0 0 2px rgba(47, 107, 134, .08);\r\n}\r\n\r\n.themeOptions {\r\n  position: absolute;\r\n  z-index: 40;\r\n  top: calc(100% + 5px);\r\n  left: 0;\r\n  right: 0;\r\n  min-width: 240px;\r\n  max-height: 330px;\r\n  overflow-y: auto;\r\n  padding: 7px;\r\n  border: 1px solid #d4dfe5;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  box-shadow: 0 10px 24px rgba(29, 54, 70, .14);\r\n}\r\n\r\n.themeOptions label {\r\n  min-height: 34px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 5px 7px;\r\n  border-radius: 7px;\r\n  color: #294252;\r\n  cursor: pointer;\r\n  font-size: .76rem;\r\n  font-weight: 400;\r\n}\r\n\r\n.themeOptions label:hover {\r\n  background: #f1f6f8;\r\n}\r\n\r\n.themeOptions input {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex: 0 0 auto;\r\n  margin: 0;\r\n  accent-color: #2f6b86;\r\n}\r\n\r\n.themeOptions .selectAllTheme {\r\n  color: #173f56;\r\n  font-weight: 700;\r\n}\r\n\r\n.themeOptionsSeparator {\r\n  height: 1px;\r\n  margin: 5px 3px;\r\n  background: #e6ecef;\r\n}\r\n\r\n.clearFilters {\r\n  min-height: 38px;\r\n  padding: 7px 12px;\r\n  border: 1px solid #b8cbd6;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #2c6079;\r\n  cursor: pointer;\r\n  font-size: .76rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.clearFilters:hover {\r\n  background: #eef6f9;\r\n}\r\n\r\n.tableWrapper {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  min-width: 1180px;\r\n  border-collapse: collapse;\r\n  color: #263746;\r\n  font-size: .82rem;\r\n}\r\n\r\n.table thead th {\r\n  padding: 11px 12px;\r\n  border-bottom: 1px solid #d9e1e6;\r\n  background: #eef1f3;\r\n  color: #294252;\r\n  text-align: left;\r\n  font-size: .76rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.table tbody td {\r\n  padding: 12px;\r\n  border-bottom: 1px solid #edf0f2;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table tbody tr:last-child td {\r\n  border-bottom: 0;\r\n}\r\n\r\n.table tbody tr:hover {\r\n  background: #f8fbfd;\r\n}\r\n\r\n.status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 78px;\r\n  padding: 5px 8px;\r\n  border: 1px solid currentColor;\r\n  border-radius: 999px;\r\n  font-size: .72rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.statusRequest {\r\n  color: #d45a5a;\r\n  background: #fff0f0;\r\n}\r\n\r\n.statusProposal {\r\n  color: #d36e8f;\r\n  background: #fff1f6;\r\n}\r\n\r\n.statusScheduled {\r\n  color: #b7771e;\r\n  background: #fff7df;\r\n}\r\n\r\n.statusCompleted {\r\n  color: #2f8b5d;\r\n  background: #eaf7f0;\r\n}\r\n\r\n.values {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 5px;\r\n  min-width: 72px;\r\n}\r\n\r\n.valueIcon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 25px;\r\n  height: 25px;\r\n  border: 1px solid currentColor;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n}\r\n\r\n.valueIcon img {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.bienveillance {\r\n  color: var(--upcare-value-bienveillance);\r\n  background: var(--upcare-value-bienveillance-soft);\r\n}\r\n\r\n.engagement {\r\n  color: var(--upcare-value-engagement);\r\n  background: var(--upcare-value-engagement-soft);\r\n}\r\n\r\n.faireEquipe {\r\n  color: var(--upcare-value-faire-equipe);\r\n  background: var(--upcare-value-faire-equipe-soft);\r\n}\r\n\r\n.respect {\r\n  color: var(--upcare-value-respect);\r\n  background: var(--upcare-value-respect-soft);\r\n}\r\n\r\n.theme {\r\n  display: inline-flex;\r\n  padding: 4px 8px;\r\n  border-radius: 999px;\r\n  background: #eaf5f9;\r\n  color: #245b72;\r\n  font-size: .72rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.titleCell {\r\n  min-width: 210px;\r\n  color: #172d3b;\r\n  font-weight: 600;\r\n}\r\n\r\n.noData {\r\n  color: #87939b;\r\n}\r\n\r\n.state,\r\n.error {\r\n  margin: 18px;\r\n  padding: 28px 18px;\r\n  border-radius: 10px;\r\n  background: #f8fafb;\r\n  color: #687782;\r\n  text-align: center;\r\n}\r\n\r\n.error {\r\n  color: #b42318;\r\n  background: #fff5f4;\r\n}\r\n\r\n@media (max-width: 1050px) {\r\n  .filters {\r\n    grid-template-columns: repeat(2, minmax(180px, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .page {\r\n    padding: .75rem;\r\n  }\r\n\r\n  .header {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .viewTabs {\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .filters {\r\n    grid-template-columns: 1fr;\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .themeOptions {\r\n    min-width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `SuiviPage_page__8NYZZ`,
	"card": `SuiviPage_card__PsPU4`,
	"header": `SuiviPage_header__6eLfl`,
	"total": `SuiviPage_total__Jbljk`,
	"viewTabs": `SuiviPage_viewTabs__hxUCz`,
	"activeViewTab": `SuiviPage_activeViewTab__O+ObX`,
	"filters": `SuiviPage_filters__GCJfd`,
	"themeFilter": `SuiviPage_themeFilter__ASsOG`,
	"themeMultiSelect": `SuiviPage_themeMultiSelect__5Quje`,
	"themeOptions": `SuiviPage_themeOptions__9I107`,
	"selectAllTheme": `SuiviPage_selectAllTheme__ouYON`,
	"themeOptionsSeparator": `SuiviPage_themeOptionsSeparator__xi4h4`,
	"clearFilters": `SuiviPage_clearFilters__QQcfq`,
	"tableWrapper": `SuiviPage_tableWrapper__vy5Cp`,
	"table": `SuiviPage_table__+dt58`,
	"status": `SuiviPage_status__0aQmE`,
	"statusRequest": `SuiviPage_statusRequest__tER0e`,
	"statusProposal": `SuiviPage_statusProposal__yWnik`,
	"statusScheduled": `SuiviPage_statusScheduled__vI2Hz`,
	"statusCompleted": `SuiviPage_statusCompleted__pwLUX`,
	"values": `SuiviPage_values__UDmG5`,
	"valueIcon": `SuiviPage_valueIcon__2mvhZ`,
	"bienveillance": `SuiviPage_bienveillance__BLKeD`,
	"engagement": `SuiviPage_engagement__iJfBP`,
	"faireEquipe": `SuiviPage_faireEquipe__xe7OE`,
	"respect": `SuiviPage_respect__Lmfet`,
	"theme": `SuiviPage_theme__E7rg3`,
	"titleCell": `SuiviPage_titleCell__WNuse`,
	"noData": `SuiviPage_noData__2fUZf`,
	"state": `SuiviPage_state__mLgj4`,
	"error": `SuiviPage_error__qCgVe`
};
export default ___CSS_LOADER_EXPORT___;
